export default "__VITE_ASSET__DpG1L0_d__"